export default __webpack_public_path__ + "static/media/product-image-12.dd9c2d65.png";